import { FontWeights, getTheme, Icon, IIconStyles, IStackStyles, ITextStyles } from "@fluentui/react";
import React, { useContext } from "react";
import { Stack, Theme, Text } from "sprint-common-web";

import { NavigationContext } from "../../../../core/configuration/navigation/NavigationContext";
import { UserInfo } from "./UserInfo";

const titleStyles: ITextStyles = {
    root: {
        color: getTheme().palette.white,
        fontSize: 16,
        fontWeight: FontWeights.regular
    }
};
const stack: IStackStyles = {
    root: {
        paddingTop: 10,
        paddingLeft: 8
    }
};
const iconStyles: IIconStyles = {
    root: {
        color: getTheme().palette.white,
        coursor: "pointer",
        paddingRight: 10,
        paddingTop: 4,
        selectors: {
            ":hover": {
                cursor: "pointer"
            }
        }
    }
};
export const Header: React.FunctionComponent = () => {
    const { toggleNavigation } = useContext(NavigationContext);

    return (
        <Stack
            horizontal={true}
            horizontalAlign="space-between"
            styles={{ root: { backgroundColor: Theme.palette.themePrimary } }}
            data-testid="header"
        >
            <Stack horizontal={true} styles={stack}>
                <Icon iconName="List" styles={iconStyles} onClick={toggleNavigation}></Icon>
                <Text styles={titleStyles}>Sprint</Text>
            </Stack>
            <Stack>
                <UserInfo />
            </Stack>
        </Stack>
    );
};
